import { Avatar, AvatarFallback, AvatarImage } from '../../../shared/ui/avatar'
import { useSelector } from 'react-redux'
import { cn, getInitials } from '../../../shared/lib/utils'
import { MoreHorizontal } from 'lucide-react'
import UserDropdown from '../../../shared/components/UserDropdown'

const FooterAvatar = ({ isCollapsed }: { isCollapsed: boolean }) => {
  const users = useSelector((state: any) => state?.users);
  const userFullName = users ? `${users.firstName || ""} ${users.lastName || ""}`.trim() : "";
  const userRole = users?.role ? users?.role : users?.roles?.[0]?.name;
  const profileImage = users?.profileImage;

  return (
    <UserDropdown side="top">
      <footer style={{
        borderTop: "1px solid",
        borderImageSource: 'radial-gradient(50.27% 7031199.26% at 50% 49.94%, #DCE0F9 0%, rgba(231, 233, 251, 0) 100%)',
        cursor: 'pointer'
      }} className={cn("flex border items-end p-2 mt-auto border-t border-gray-40 outline-none",
        isCollapsed ? "justify-center " : "md:justify-center lg:justify-start"
      )}>
        <div className="flex items-center md:justify-center lg:justify-between w-full md:gap-1 lg:gap-2">
          <div className="flex items-center justify-center gap-2 md:w-auto w-5/6 lg:w-5/6">
            <Avatar >
              <AvatarImage
                src={profileImage}
                alt="@profile picture"
                className=""
              />
              <AvatarFallback className='bg-primary-30 text-white text-xs'>{getInitials(userFullName)}</AvatarFallback>
            </Avatar>
            <div className={cn("w-full overflow-hidden", isCollapsed ? 'hidden' : "block md:hidden lg:block")}>
              <p className="w-11/12 truncate whitespace-nowrap text-sm font-[450] text-gray-30">{userFullName}</p>
              <p className="text-xs font-normal text-gray-20">{userRole}</p>
            </div>
          </div>
          {isCollapsed ? null : <div className="w-1/6 flex justify-end"><MoreHorizontal size={20} /></div>}
        </div>
      </footer>
    </UserDropdown>
  )
}

export default FooterAvatar
